<sc-flex fitHeight centered>
  <sc-flex>
    <div>
      @for (image of imageSrcFiles; track $index) {
      <img [src]="image" />
      }
    </div>
    <div>
      @if (titleDictionaryKey) {
      <sc-title>
        <sc-dictionary-label [dictionaryKey]="titleDictionaryKey"></sc-dictionary-label>
      </sc-title>
      <sc-content-spacer vertical double></sc-content-spacer>
      }
      @for (contentDictionaryKey of contentDictionaryKeys; track $index) {
      @if($index > 0) {
      <sc-content-spacer vertical></sc-content-spacer>
      }
      <div>
        <sc-dictionary-label [dictionaryKey]="contentDictionaryKey"></sc-dictionary-label>
      </div>
      }
    </div>
  </sc-flex>
</sc-flex>
